import { lazyLoad } from 'utils/loadable';

export const SupportCenterPage = lazyLoad(
  () => import('./SupportCenterPage'),
  module => module.SupportCenterPage,
);
